import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../constants';
import { useAuth } from '../../hooks/useAuth';
import { authCookies } from '../../utils/cookies';
import { decodeAndValidateToken } from '../../utils/tokenUtils';

const LoginCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { refreshAuth, isAuthenticated } = useAuth();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const handleCallback = async () => {
            const code = new URLSearchParams(location.search).get('code');
            const error = new URLSearchParams(location.search).get('error');
            const errorDescription = new URLSearchParams(location.search).get('error_description');

            if (error) {
                console.error('[LoginCallback] OAuth error:', error, errorDescription);
                const errorMessage = errorDescription || 'Authentication failed';
                navigate(`/login?error=${error}&error_description=${encodeURIComponent(errorMessage)}`, { replace: true });
                return;
            }

            if (!code && !success && !isAuthenticated) {
                navigate('/login', { replace: true });
                return;
            }

            try {
                const response = await axios.get(
                    `${API_URL}/auth/token?code=${code}&redirect_url=${window.location.origin}/login/callback`
                );
                if (response.data.error) throw new Error(response.data.error);
                authCookies.setIdToken(response.data.id_token);
                authCookies.setAccessToken(response.data.access_token);
                authCookies.setRefreshToken(response.data.refresh_token);
                if (response.data.id_token) decodeAndValidateToken(response.data.id_token);
                if (response.data.access_token) decodeAndValidateToken(response.data.access_token);
                await refreshAuth();
                setSuccess(true);
                window.location.href = '/';
                return;
            } catch (err) {
                if (success) {
                    navigate('/', { replace: true });
                    return;
                }
                console.error('[LoginCallback] Error:', err);
                const errorMessage = err instanceof Error ? err.message : 'Authentication failed';
                navigate(`/login?error=invalid_request&error_description=${encodeURIComponent(errorMessage)}`, { replace: true });
            } finally {
                setLoading(false);
            }
        };
        handleCallback();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
            <div>Finishing authentication...</div>
        </div>
    );
};

export default LoginCallback; 